import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getAllSubscribers = async () => {
  try {
    // Get response
    let response = await axios.get(`${BASE_URL}/get/all/subscribers`);
    return response.data;
  } catch (err) {
    console.log("ERR_GET_FILTER_BY_CATEGORY_BANK_API:", err);
    throw err;
  }
};
